import React from 'react';
import {Route} from 'react-router-dom';
import {SessionManager} from "../../session-manager";

export class PrivateComponent extends React.Component {
    render() {
        return SessionManager.isAuthenticated() ? <Route {...this.props} /> : ''
    }
}